
import { supabase } from './supabaseClient';

export interface AdminBoundary {
  id: number;
  code: string;
  name_en: string;
  name_kh: string;
  level: 'COUNTRY' | 'PROVINCE' | 'DISTRICT' | 'COMMUNE' | 'VILLAGE';
  parent_id: number | null;
}

export const fetchAdminBoundaries = async (level: string | string[] = 'PROVINCE') => {
  let query = supabase
    .from('admin_boundaries')
    .select('*')
    .order('name_en', { ascending: true });

  if (Array.isArray(level)) {
    query = query.in('level', level);
  } else {
    query = query.eq('level', level);
  }

  const { data, error } = await query;

  if (error) {
    console.error('Error fetching boundaries:', error);
    throw error;
  }
  return data as AdminBoundary[];
};
